import ClubName from "../ClubName";
import Link from "app/components/UI/Link";
import React from "react";
import classes from "./ChangeClub.module.css";

export const ChangeClub = ({ translate, translateHtml, onClose, isOpen, onChangeClub, onChangeClubConfirm }) => (
  <div>
    <ClubName />
    <Link to="/" className={classes.changeClub}>
      {translate("Choisir un Golf")}
    </Link>
  </div>
);

export default ChangeClub;



// WEBPACK FOOTER //
// ./src/app/components/CurrentClub/ChangeClub/ChangeClub.js